import { Space, Tooltip } from "antd"
import IconAndTextButton from "../IconAndTextButton"
import { faTrash, faTrashRestore } from "@fortawesome/pro-solid-svg-icons"
import EditPropertyContext from "./EditPropertyContext"
import { useContext } from "react"
import { useDeletePropertyMutation, useRestorePropertyMutation } from "./propertyQueries"

const DeleteRestoreProperty = () => {
  const { selectedPropertyId, property, selectProperty, showDeletedView } = useContext(EditPropertyContext)
  const deleteMutation = useDeletePropertyMutation(() => selectProperty(undefined, true))
  const restoreMutation = useRestorePropertyMutation(() => selectProperty(undefined, true))

  const hasProperties = property && property.projects > 0
  const deleteDisabled = hasProperties || showDeletedView
  const deleteButton = <IconAndTextButton
    danger
    type="primary"
    size="large"
    icon={faTrash}
    text="Delete Property"
    disabled={deleteDisabled}
    onClick={() => { 
      if (property?.customerId && selectedPropertyId) {
        deleteMutation.mutate({customerId: property?.customerId, propertyId: selectedPropertyId})
      }
    }}
  />
  const deleteControl = deleteDisabled && hasProperties
    ? <Tooltip title="This property cannot be removed because there are associated jobs. To remove this property, first remove the jobs."><span>{deleteButton}</span></Tooltip>
    : deleteButton

  return <Space>
    {deleteControl}
    {showDeletedView && <IconAndTextButton
      type="primary"
      size="large"
      icon={faTrashRestore}
      text="Restore Property"
      onClick={() => {
        if (selectedPropertyId) {
          restoreMutation.mutate(selectedPropertyId)
        }
      }}
    />}
  </Space>
}

export default DeleteRestoreProperty
